import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["country", "currency", "employeeDiscount", "employeePrice", "featureList", "localeForCurrency", "isSwoosh", "listPrice", "nikeType", "onSale", "salePrice", "renderDiscountAddendum", "renderFullPricePrefix"];
import React from 'react';
import PropTypes from 'prop-types';
import { canUseDOM } from 'exenv';
import { PriceContainer } from './styled';
import FinalPrice from './final-price';
var ProductPrice = function ProductPrice(_ref) {
  var country = _ref.country,
    currency = _ref.currency,
    employeeDiscount = _ref.employeeDiscount,
    employeePrice = _ref.employeePrice,
    featureList = _ref.featureList,
    localeForCurrency = _ref.localeForCurrency,
    isSwoosh = _ref.isSwoosh,
    listPrice = _ref.listPrice,
    nikeType = _ref.nikeType,
    onSale = _ref.onSale,
    salePrice = _ref.salePrice,
    renderDiscountAddendum = _ref.renderDiscountAddendum,
    renderFullPricePrefix = _ref.renderFullPricePrefix,
    intlOptions = _objectWithoutProperties(_ref, _excluded);
  // determines which markup to display
  // this canUseDOM is due to the price component not working on the server side
  if (canUseDOM) {
    var isGiftCertificate = /GIFTCERTIFICATE/i.test(nikeType);
    var hasEmployeeDiscount = isSwoosh === true && employeeDiscount === '1';
    var isOnSale = onSale === '1';
    var finalPrice;
    if (!listPrice) finalPrice = null;
    finalPrice = /*#__PURE__*/React.createElement("span", {
      className: "not-shown"
    }, listPrice);

    // Returns markup, but the price is not shown to a user due to gift card or
    // locale rules on price display
    if (featureList && featureList.PRICING_RECS && !isGiftCertificate) {
      finalPrice = /*#__PURE__*/React.createElement(FinalPrice, _extends({}, intlOptions, {
        country: country,
        currency: currency,
        employeeDiscount: employeeDiscount,
        employeePrice: employeePrice,
        hasEmployeeDiscount: hasEmployeeDiscount,
        localeForCurrency: localeForCurrency,
        isOnSale: isOnSale,
        isSwoosh: isSwoosh,
        listPrice: listPrice,
        onSale: onSale,
        salePrice: salePrice,
        renderDiscountAddendum: renderDiscountAddendum,
        renderFullPricePrefix: renderFullPricePrefix
      }));
    }
    return /*#__PURE__*/React.createElement(PriceContainer, {
      className: "price",
      "data-version": "__VERSION_HERE__"
    }, listPrice && finalPrice);
  }
  return null;
};
ProductPrice.defaultProps = {
  featureList: {}
};
ProductPrice.propTypes = {
  /**
   * country code, preferred as lowercase. Used for Japan addendum logic.
   */
  country: PropTypes.string.isRequired,
  /**
   * currency code, preferred in caps
   */
  currency: PropTypes.string.isRequired,
  /**
   * the listPrice of a product (eg from merch/price/v1)
   */
  listPrice: PropTypes.string,
  /**
   * the employee discount price for a product
   */
  employeePrice: PropTypes.string,
  /**
   * whether the user is eligible for employee discounts ('1' is true, '0' is false)
   */
  employeeDiscount: PropTypes.string,
  /**
   * the locale value from which to format the specified currency
   */
  localeForCurrency: PropTypes.string.isRequired,
  /**
   * whether the item is on sale ('1' is true, '0' is false)
   */
  onSale: PropTypes.string,
  /**
   * the sale price for a product
   */
  salePrice: PropTypes.string,
  /**
   * whether the user has a swoosh account
   */
  isSwoosh: PropTypes.bool,
  /**
   * the nikeType attribute of a product (to identify if it's a giftCard)
   */
  nikeType: PropTypes.string,
  featureList: PropTypes.objectOf(PropTypes.bool),
  /**
   * Discount addendum for Japan sale price
   */
  renderDiscountAddendum: PropTypes.func,
  /**
   * Price prefix for India full retail price
   */
  renderFullPricePrefix: PropTypes.func
};
export default ProductPrice;